import { LoadMore } from '@tbitop/mobile-app';
import { LoadingSpinner, Paragraph } from '@tbitop/ui';
import type { Kampagne } from '../../../infrastructure/graphql/KampagnenSeitenweiseQuery';
import { KampagnenListItem } from './kampagnen-list-item';

type KampagnenListePaginationProps = {
  kampagnen: Kampagne[];
  pageLoading: boolean;
  pagination: {
    hasMore: boolean;
    fetchMore: () => Promise<void>;
  };
};

export const KampagnenListPagination = ({ kampagnen, pagination, pageLoading }: KampagnenListePaginationProps) => {
  return <>
    {pageLoading && (
      <div className="flex items-center justify-center my-48">
        <LoadingSpinner />
      </div>
    )}

    {!pageLoading && kampagnen.length === 0 && (
      <Paragraph className="text-center text-tds-color-copy-on-light-10">
          Keine Daten verfügbar
      </Paragraph>
    )}

    <ul className="flex flex-col overflow-y-auto gap-100" aria-label="Aufgabenliste">
      {kampagnen.map(kampagne => (
        <KampagnenListItem kampagne={kampagne} key={kampagne.aufgabenId} href={`/aktionsaufgabe-erstellen/${kampagne.aufgabenId}/${encodeURIComponent(kampagne.name)}`} />
      ))}
    </ul>

    {!pageLoading && <LoadMore hasMore={pagination.hasMore} onLoadMore={() => pagination.fetchMore()} />}
  </>;
};
